import Vue from "vue";
import Vuex from "vuex";
import * as types from "./types";


Vue.use(Vuex);

const state = {
	// 页面切换滑动方向
	direction: "forward",
	//includePage: ['Index', 'NewsList', 'EnterpriseList'], // 缓存路由集合 
	// 缓存路由集合 
	keepAlive: ['Index'],
	// 主页子路由
	indexKeepAlive: ['home'],
	//全局加载遮盖层是否显示
	loadShow: false,
	//全局加载遮盖层是否显示
	loadText: '加载中...',
	//全局加载遮盖层显示层级 0不显示 大于0显示
	loadShowLevel: 0,
	//登录信息
	loginInfo: '',
	//用户token
	token: '',
	//用户跳转定制页面
	homeUrl: '',
	//登录跳转注册
	userNames: [],
	//用户信息
	userInfo: '',
	//消息数量
	messageCount: 0,
	//存证查验缓存信息
	certificateVerificationInfo: '',
	//CA证书缓存信息
	certInfo: '',
	//印模缓存信息
	signetInfo: null,
	//是否重新登录
	reLogin: '',
	//
	indexActive: 0,
	//企业认证流程信息
	enterpriseAuthInfo: {},
	//企业认证流程方向 1前进 2 后退
	enterpriseAuthDirection: 1,
	//缓存合同是否签署需要查询变更状态
	contractStatus: false,
	//缓存企业是否刷新
	enterpriseRefresh: false,
	//缓存企业是否删除
	enterpriseDelete: false,
	//缓存企业是否重新认证
	enterpriseReAuth: false,
	//缓存系统分享进应用文件
	newquicksignfiles: '',
	//缓存鸿蒙分享进应用文件
	harmonysharefiles: '',
	//
	quickSignContractDetails: '',

	//单点登录登录来源
	sourceFlag: ''
};

const getters = {
	direction: state => state.direction,
	keepAlive: state => state.keepAlive,
	indexKeepAlive: state => state.indexKeepAlive,
};

const mutations = {
	[types.UPDATE_DIRECTION](state, update) {
		state.direction = update.direction;
	},
	// [types.UPDATE_INCLUDE_PAGE](state, obj) {
	// 	if (obj.pageName) {
	// 		let _index = state.includePage.indexOf(obj.pageName);
	// 		if (obj.flag) {
	// 			if (_index === -1) {
	// 				state.includePage.push(obj.pageName);
	// 			}
	// 		} else {
	// 			if (_index > -1) {
	// 				state.includePage.splice(_index, 1);
	// 			}
	// 		}
	// 	}
	// },

	//所有页面路由缓存开关数组
	setKeepAlive(state, keepAlive) {
		state.keepAlive = keepAlive;
	},
	addKeepAlive(state, name) {
		if (state.keepAlive.indexOf(name) == -1) {
			state.keepAlive.push(name);
		}
	},
	removeKeepAlive(state, name) {
		let idx = state.keepAlive.indexOf(name)
		if (-1 != idx) {
			state.keepAlive.splice(idx, 1)
		}
	},

	//index主页面路由缓存开关数组
	setIndexKeepAlive(state, keepAlive) {
		state.indexKeepAlive = keepAlive;
	},
	addIndexKeepAlive(state, name) {
		if (state.indexKeepAlive.indexOf(name) == -1) {
			state.indexKeepAlive.push(name);
		}
	},
	removeIndexKeepAlive(state, name) {
		let idx = state.indexKeepAlive.indexOf(name)
		if (-1 != idx) {
			state.indexKeepAlive.splice(idx, 1)
		}
	},
	// 登录信息
	changeLoginInfo(state, val) {
		state.loginInfo = val
	},
	// 用户token
	changeLoginToken(state, val) {
		state.token = val
	},
	// 用户定制路由路径
	changeHomeUrl(state, val) {
		state.homeUrl = val
	},
	// 登录跳转注册
	changeUserNames(state, val) {
		state.userNames = val
	},
	// 用户信息
	changeUserInfo(state, val) {
		state.userInfo = val
	},
	// 用户信息
	changeMessageCount(state, val) {
		state.messageCount = val
	},
	// 存证查验缓存信息
	changeCertVerifInfo(state, val) {
		state.certificateVerificationInfo = val
	},
	// CA证书缓存信息
	changeCertInfo(state, val) {
		state.certInfo = val
	},
	// 印模缓存信息
	changeSignetInfo(state, val) {
		state.signetInfo = val
	},
	// 全局加载遮盖层是否显示
	[types.UPDATE_LOAD_SHOW](state, val) {
		state.loadShow = val
	},
	// 全局加载遮盖层是否显示
	[types.UPDATE_LOAD_TEXT](state, val) {
		state.loadText = val
	},
	//更新加载遮盖层层级
	[types.UPDATE_LOAD_SHOW_LEVEL](state, val) {
		if (val) {
			state.loadShowLevel += 1
		} else {
			state.loadShowLevel -= 1
		}
		//console.log('loadShowLevel', state.loadShowLevel, val)
		if (state.loadShowLevel > 0) {
			state.loadShow = true
		} else {
			state.loadShowLevel = 0
			state.loadShow = false
		}
	},
	//增加加载遮盖层层级
	[types.ADD_LOAD_SHOW_LEVEL](state, val) {
		state.loadShowLevel += 1
		if (state.loadShowLevel > 0) {
			state.loadShow = true
		}
	},
	//减少加载遮盖层层级
	[types.REDUCE_LOAD_SHOW_LEVEL](state, val) {
		state.loadShowLevel -= 1
		if (state.loadShowLevel <= 0) {
			state.loadShowLevel = 0
			state.loadShow = false
		}
	},
	//加载遮盖层层级为0
	[types.RESET_LOAD_SHOW_LEVEL](state, val) {
		state.loadShowLevel = 0
		state.loadShow = false
	},
	// 是否重新登录
	changeReLogin(state, val) {
		state.reLogin = val
	},
	//
	changeIndexActive(state, val) {
		state.indexActive = val
	},
	// 企业和法人信息
	changeEnterpriseAuthInfo(state, val) {
		state.enterpriseAuthInfo = val
	},
	// 企业认证流程方向
	changeEnterpriseAuthDirection(state, val) {
		state.enterpriseAuthDirection = val
	},
	// 缓存合同是否签署需要查询变更状态
	changeContractStatus(state, val) {
		state.contractStatus = val
	},
	// 缓存企业列表是否刷新
	changeEnterpriseRefresh(state, val) {
		state.enterpriseRefresh = val
	},
	//缓存企业是否重新认证
	changeEnterpriseReAuth(state, val) {
		state.enterpriseReAuth = val
	},
	//缓存企业是否删除
	changeEnterpriseDelete(state, val) {
		state.enterpriseDelete = val
	},
	changeNewQuickSignFiles(state, val) {
		state.newquicksignfiles = val
	},
	changeHarmonyShareFiles(state, val) {
		state.harmonysharefiles = val
	},
	changeQuickSignContractDetails(state, val) {
		state.quickSignContractDetails = val
	},
	changeSourceFlag(state, val) {
		state.sourceFlag = val
	}
};

const actions = {
	[types.ADD_NEW_QUICK_SIGN_FILES](context, update) {
		context.commit('changeNewQuickSignFiles', update);
	},
	[types.UPDATE_DIRECTION](context, update) {
		context.commit(types.UPDATE_DIRECTION, update);
	},
	[types.UPDATE_INCLUDE_PAGE](context, obj) {
		context.commit(types.UPDATE_INCLUDE_PAGE, obj);
	},
	[types.UPDATE_LOAD_SHOW](context, value) {
		context.commit(types.UPDATE_LOAD_SHOW, value);
	},
	[types.UPDATE_LOAD_TEXT](context, value) {
		context.commit(types.UPDATE_LOAD_TEXT, value);
	},
	//更新加载遮盖层层级
	[types.UPDATE_LOAD_SHOW_LEVEL](context, value) {
		context.commit(types.UPDATE_LOAD_SHOW_LEVEL, value);
	},
	//增加加载遮盖层层级
	[types.ADD_LOAD_SHOW_LEVEL](context, value) {
		context.commit(types.ADD_LOAD_SHOW_LEVEL, value);
	},
	//减少加载遮盖层层级
	[types.REDUCE_LOAD_SHOW_LEVEL](context, value) {
		context.commit(types.REDUCE_LOAD_SHOW_LEVEL, value);
	},
	//加载遮盖层层级为0
	[types.RESET_LOAD_SHOW_LEVEL](context, value) {
		context.commit(types.RESET_LOAD_SHOW_LEVEL, value);
	},
	actionUserInfo(context, value) {
		context.commit('changeUserInfo', value);
	},
	actionMessageCount(context, value) {
		context.commit('changeMessageCount', value);
	},
	actionHarmonyShareFiles(context, value) {
		context.commit('changeHarmonyShareFiles', value);
	},
	actionQuickSignContractDetails(context, value) {
		context.commit('changeQuickSignContractDetails', value);
	},
	actionSourceFlag(context, value) {
		context.commit('changeSourceFlag', value);
	},
};

export default new Vuex.Store({
	strict: process.env.NODE_ENV !== "production",
	state,
	actions,
	getters,
	mutations,
});